//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import '@streams-drawer/streams-drawer-stream-description/streams-drawer-stream-description';

import { IStream } from '../model/IStream';
import { IStreamItemSet } from '../model/IStreamItemSet';
import {
  nameToStreamType,
  StreamsDrawerStreamType,
  getRecommendedStreamName,
} from '../streams-drawer-constants';

import template from './streams-drawer-summary-section.html';
import './streams-drawer-summary-section.less';

class StreamsDrawerSummarySection {
  public itemSet: IStreamItemSet;
  public stream: IStream;
  public selectStream;
  public streamType: StreamsDrawerStreamType;
  public streamName: String;
  public autoConfigTbbEnabled: boolean;

  constructor(private TrackingService, private SessionVarsService) {}

  public onViewAllClick(stream: IStream) {
    this.TrackingService.recordEvent(
      this.TrackingService.CATEGORY_STREAMS,
      this.TrackingService.ACTION_STREAMS_SELECT_STREAM_FROM_BUTTON,
      `stream-type=${this.streamType}`,
    );

    this.selectStream({ stream });
  }

  public leftClickCallback() {
    this.TrackingService.recordEvent(
      this.TrackingService.CATEGORY_STREAMS,
      this.TrackingService.ACTION_STREAMS_LEFT_ARROW_CLICKED,
      `stream-type=${this.streamType}`,
    );
  }

  public rightClickCallback() {
    this.TrackingService.recordEvent(
      this.TrackingService.CATEGORY_STREAMS,
      this.TrackingService.ACTION_STREAMS_RIGHT_ARROW_CLICKED,
      `stream-type=${this.streamType}`,
    );
  }

  public $onInit() {
    this.stream = this.itemSet.stream;
    this.streamType = nameToStreamType(this.stream);
    this.streamName = getRecommendedStreamName(this.stream);
    this.autoConfigTbbEnabled = this.SessionVarsService.isFeatureEnabled(
      'automated_tagged_by_bazaarvoice',
    );
  }
}

angular.module('curalate').component('streamsDrawerSummarySection', {
  bindings: {
    autoConfigTbbEnabled: '<',
    selectStream: '&',
    itemSet: '<',
    onOpenCurrentApprovalModal: '&',
    onOpenAutoApprovalModal: '&',
  },
  controller: [
    'TrackingService',
    'SessionVarsService',
    StreamsDrawerSummarySection,
  ],
  template,
});
